var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"buttonWrap",staticClass:"app-button-on-scroll"},[_c('adm-icon-button',{staticClass:"btn-scroll-top",attrs:{"id":"btn_scroll_top","icon":_vm.icon,"variant":"primary","theme":"inverted"},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }